var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "worldview-form" }, [
    _c(
      "div",
      { staticClass: "form" },
      [
        _c("text-field", {
          attrs: {
            label: _vm.$t("createWorldViewPage.nameLabel"),
            placeholder: _vm.$t("createWorldViewPage.namePlaceholder"),
            maxlength: 50,
          },
          on: { input: _vm.change },
          model: {
            value: _vm.name,
            callback: function ($$v) {
              _vm.name = $$v
            },
            expression: "name",
          },
        }),
        _vm._l(_vm.detail, function (item) {
          return [
            _c("text-field", {
              key: item.name,
              attrs: {
                label: item._label,
                placeholder: item._placeholder,
                maxlength: 2000,
                rows: item._rows || 1,
              },
              on: { input: _vm.change },
              model: {
                value: item.value,
                callback: function ($$v) {
                  _vm.$set(item, "value", $$v)
                },
                expression: "item.value",
              },
            }),
          ]
        }),
        _c("p", { staticClass: "premium-label" }, [
          _c("img", {
            attrs: {
              src: require("@/assets/img/icon/premium.png"),
              width: "18",
            },
          }),
          _c("span", [
            _vm._v(_vm._s(_vm.$t("createWorldViewPage.addCustomFieldLabel"))),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "additional-column" },
          [
            _vm._l(_vm.additionalColumn, function (item, index) {
              return [
                _c(
                  "div",
                  {
                    key: index,
                    staticClass: "additional-content",
                    attrs: { id: index },
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: index != _vm.additionalColumn.length - 1,
                            expression: "index != additionalColumn.length - 1",
                          },
                        ],
                        staticClass: "remove-button",
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/img/icon/remove.png"),
                            width: "18",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.remove(index)
                            },
                          },
                        }),
                      ]
                    ),
                    _c("text-field", {
                      key: `label-${item.name}`,
                      ref: `label-${item.name}`,
                      refInFor: true,
                      attrs: {
                        label: _vm.$t("createWorldViewPage.customFieldLabel"),
                        placeholder: _vm.$t(
                          "createWorldViewPage.customFieldPlaceholder"
                        ),
                        maxlength: 30,
                        disabled: _vm.plan === 0,
                        id: `label-${item.name}`,
                      },
                      on: { input: _vm.change },
                      model: {
                        value: item.label,
                        callback: function ($$v) {
                          _vm.$set(item, "label", $$v)
                        },
                        expression: "item.label",
                      },
                    }),
                    _c("text-field", {
                      key: `content-${item.name}`,
                      ref: `content-${item.name}`,
                      refInFor: true,
                      attrs: {
                        label: _vm.$t(
                          "createWorldViewPage.customFieldContentLabel"
                        ),
                        placeholder: _vm.$t(
                          "createWorldViewPage.customFieldContentPlaceholder"
                        ),
                        disabled: _vm.plan === 0,
                        rows: 4,
                        id: `content-${item.name}`,
                      },
                      on: { input: _vm.change },
                      model: {
                        value: item.content,
                        callback: function ($$v) {
                          _vm.$set(item, "content", $$v)
                        },
                        expression: "item.content",
                      },
                    }),
                  ],
                  1
                ),
              ]
            }),
            _c("div", { staticClass: "button-center" }, [
              _c(
                "button",
                {
                  staticClass: "button",
                  attrs: { disabled: _vm.plan === 0 },
                  on: {
                    click: function ($event) {
                      return _vm.add()
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("createWorldViewPage.addMoreFieldsButton"))
                  ),
                ]
              ),
            ]),
            _vm.plan === 0 ? _c("premium-information") : _vm._e(),
          ],
          2
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }